import * as React from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '~/lib/utils'

// 미니멀 네이티브 select — Input과 동일 보더/포커스/치수 + 우측 ChevronDown.
// 네이티브 화살표는 appearance-none으로 숨기고 lucide 아이콘을 겹친다.
export type SelectProps = Omit<React.ComponentProps<'select'>, 'size'> & {
    size?: 'sm' | 'md' | 'lg'
    error?: boolean
}

/** 네이티브 select + 우측 chevron. */
function Select({
    className,
    size = 'md',
    error = false,
    ref,
    ...props
}: SelectProps) {
    return (
        <div className='relative w-full'>
            <select
                ref={ref}
                data-slot='select'
                aria-invalid={error || undefined}
                className={cn(
                    'border-input bg-card text-foreground focus:border-primary focus:ring-ring/20 disabled:bg-muted w-full appearance-none rounded-[var(--radius)] border pr-8 pl-2.5 text-[13px] transition-colors focus:ring-2 focus:outline-none disabled:opacity-50',
                    size === 'sm' ? 'h-7' : 'h-8',
                    error &&
                        'border-destructive focus:border-destructive focus:ring-destructive/20',
                    className
                )}
                {...props}
            />
            <ChevronDown
                aria-hidden
                className='text-muted-foreground pointer-events-none absolute top-1/2 right-2.5 size-4 -translate-y-1/2'
            />
        </div>
    )
}

export { Select }
